/* istanbul ignore file */
import React from 'react';
import {
  READ_CANDIDATE_NOTES_PERMISSION,
  UPDATE_CANDIDATE_NOTE_PERMISSION,
} from 'domain/recruiting/candidate/Timeline/note/note/candidateNoteService';
import { HtmlField } from 'framework/ui/field';
import CandidateNoteTag from 'domain/recruiting/candidate/Timeline/note/shared/NoteTimelineRecordLayout/CandidateNoteTag';
import { TimelineCollapsible } from 'framework/ui/timeline';
import { candidateTimelineRecords } from 'domain/recruiting/candidate/shared/timeline';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { CANDIDATE_TIMELINE_ICONS, CANDIDATE_TIMELINE_MESSAGE_CONTEXT } from 'domain/shared/candidate';
import { Box } from '@mui/material';
import { feedbackTimelineFooterSx } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

type NoteTimelineRecordLayoutProps = {
  onEdit: () => void;
  actionName: string;
};

const NoteTimelineRecordLayout = ({ onEdit, actionName, ...props }: NoteTimelineRecordLayoutProps) => {
  const buttons = [
    <EditTimelineRecordButton permissionToCheck={UPDATE_CANDIDATE_NOTE_PERMISSION} key="edit" onEdit={onEdit} />,
  ];

  return (
    <BasePersonTimelineRecordLayout
      permissionToCheck={READ_CANDIDATE_NOTES_PERMISSION}
      actionName={actionName}
      timelineType={candidateTimelineRecords.NOTE_CREATED}
      timelineIcons={CANDIDATE_TIMELINE_ICONS}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      buttons={buttons}
      fields={
        <TimelineCollapsible>
          <HtmlField source="noteText" label="" />
        </TimelineCollapsible>
      }
      timelineFooter={rest => (
        <Box sx={feedbackTimelineFooterSx}>
          <CandidateNoteTag {...rest} />
        </Box>
      )}
      {...props}
    />
  );
};

export default NoteTimelineRecordLayout;
